module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-selectize-driver"
  }, [(_vm.options) ? _c('selectize', {
    attrs: {
      "selectedValue": _vm.selectedValue,
      "options": _vm.options,
      "value-field": "id",
      "maxItems": _vm.maxItems,
      "label-field": "name",
      "items": _vm.items,
      "searchField": _vm.searchableFields,
      "optionTemplate": _vm.optionTemplate,
      "renderTemplate": _vm.renderTemplate,
      "placeholder": "Cards"
    },
    on: {
      "itemAdded": _vm.optionSelected
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-756ca906!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/lists/selectize/SelectizeCard.vue
// module id = 2601
// module chunks = 1